import React, { useEffect, useState, useRef } from "react"
import { MDBDataTable } from "mdbreact"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button,
    Modal,
    FormGroup,
    Form,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Link } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
// Import images
import substrateImg from "../../assets/images/SubstrateImg.png"
import fruitingImg from "../../assets/images/fruiting1.png"

import "../Batch/datatables.scss"
import { useFormik } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatatableTables = props => {
    document.title = "Due - Today | My Urban Farms"
    const adminKey = sessionStorage.getItem("pk_admin_key");

    const [farmList, setFarmList] = useState([])

    const [selectedFarmKey, setSelectedFarmKey] = useState("");

    const breadcrumbItems = [
        // { title: "Batch Details", link: "#" },
    ]

    const [dues, setDues] = useState([])



    useEffect(() => {
        props.setBreadcrumbItems("Due - Today", breadcrumbItems)
        fetchFarms();
    }, [])



    const fetchReportsByBatch = async (selectedFarmKey) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getDueToday/due/`,
                { farmKey: selectedFarmKey }
            );

            const list = res.data.message?.data || [];

            const tableRows = list.map((item, index) => ({
                sno: index + 1,
                batch_name: item.batch_name,
                batch_num: item.batch_num,
                bag_num: item.bag_num,
                process_name: item.process_name,
                process_date: item.process_date,
                process_duration: item.process_duration
            }));

            setDues(tableRows);

        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch");
        }
    };


    const data = {
        columns: [
            { label: "S.No", field: "sno", sort: "asc", width: 50 },
            { label: "Batch Name", field: "batch_name", sort: "asc" },
            { label: "Batch Number", field: "batch_num", sort: "asc" },
            { label: "Bag Number", field: "bag_num", sort: "asc" },
            { label: "Process Name", field: "process_name", sort: "asc" },
            { label: "Process Start Date", field: "process_date", sort: "asc" },
            { label: "Process Duration", field: "process_duration", sort: "asc" },

        ],
        rows: []
    };

    const fetchFarms = async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getAllFarms/farm/`
            );

            const resData = response.data;

            if (resData.message?.success && Array.isArray(resData.message.data)) {
                setFarmList(resData.message.data);

                // Auto-select farm id=1 from list
                const defaultFarm = resData.message.data.find(f => f.pk_farm_id == 1);
                if (defaultFarm) {
                    setSelectedFarmKey(defaultFarm.pk_farm_key);
                }
            } else {
                console.warn("Unexpected data format", resData);
                setFarmList([]);
            }
        } catch (error) {
            console.error("Failed to fetch:", error);
            setFarmList([]);
            toast.error("Failed to fetch!", { autoClose: 3000 });
        }
    };

    useEffect(() => {
        if (selectedFarmKey) {
            fetchReportsByBatch
                (selectedFarmKey);
        }
    }, [selectedFarmKey]);

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb />
                <div className="mt-2 me-3" style={{ minWidth: "250px" }}>
                    <select
                        className="form-select"
                        value={selectedFarmKey}
                        onChange={(e) => setSelectedFarmKey(e.target.value)}
                    >
                        <option value="">-- Select Farm --</option>
                        {farmList.map((farm) => (
                            <option key={farm.pk_farm_key} value={farm.pk_farm_key}>
                                {farm.farm_name}
                            </option>
                        ))}
                    </select>
                </div>

            </div>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <MDBDataTable
                                responsive
                                striped
                                bordered
                                data={{ ...data, rows: dues }}
                                noBottomColumns
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>


        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables)
